import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Input, Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type {
  FormValues,
  LikesGivenRule as LikesGivenRuleType,
} from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
}

export const LikesGivenRule = ({ form, options }: Props) => (
  <RuleLayout
    top={
      <Select
        value={'LikesGiven' satisfies LikesGivenRuleType['type']}
        label="Requirement to earn badge"
        options={options}
        onValueChange={(value) => {
          const newRules = form.values.rules.map((rule) =>
            rule.type === 'LikesGiven' ? { type: value } : rule,
          )

          form.setFieldValue(FormFields.rules, newRules)
        }}
      />
    }
    bottom={
      <>
        <Input {...form.getFieldProps(FormFields.likesGivenMin)} label="Min. likes number" />
        <Input
          {...form.getFieldProps(FormFields.likesGivenMax)}
          label="Max. likes number"
          suggestion="Leave empty for infinite"
        />
      </>
    }
    onRemove={() => {
      form.setFieldValue(
        FormFields.rules,
        form.values.rules.filter(
          (rule) => rule.type !== ('LikesGiven' satisfies LikesGivenRuleType['type']),
        ),
      )
    }}
  />
)
